import { render, staticRenderFns } from "./EventListView.vue?vue&type=template&id=497af6ed&"
import script from "./EventListView.vue?vue&type=script&lang=js&"
export * from "./EventListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports